import { render, staticRenderFns } from "./dialog-add-user.vue?vue&type=template&id=38d5a2d6"
import script from "./dialog-add-user.vue?vue&type=script&lang=js"
export * from "./dialog-add-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports